export default {
  type: "Feature",
  properties: {
    name: "Чойр",
    location: [46.08530692247439, 108.48639066424525],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [107.9568099975586, 46.77467126314099],
        [108.00315856933594, 46.793478474902564],
        [108.04779052734375, 46.803819640791566],
        [108.20159912109374, 46.81509864599243],
        [108.47900390625, 46.78031411656016],
        [108.70697021484375, 46.86113003765812],
        [108.7591552734375, 46.894923891703606],
        [108.82095336914062, 46.98025235521883],
        [108.82232666015625, 46.98399993718925],
        [108.88275146484375, 46.922131240914],
        [108.91571044921875, 46.856434763486966],
        [108.9788818359375, 46.83389173208538],
        [109.00634765625, 46.81509864599243],
        [108.99810791015625, 46.779373682055635],
        [108.96514892578124, 46.68147880091785],
        [108.9678955078125, 46.60228013300284],
        [108.9788818359375, 46.50406399740093],
        [108.95862579345703, 46.463876433008494],
        [108.95965576171875, 46.464349400461124],
        [108.92669677734374, 46.42365918046987],
        [108.90884399414062, 46.38246489326114],
        [108.83331298828124, 46.3023549043942],
        [108.720703125, 46.214050815339526],
        [108.66989135742188, 46.18363372751015],
        [108.62457275390625, 46.08275685027116],
        [108.599853515625, 45.98837476770814],
        [108.56826782226561, 45.95878764035642],
        [108.55899810791016, 45.94112327491896],
        [108.55899810791016, 45.94112327491896],
        [108.42338562011719, 45.93467676685795],
        [108.31146240234375, 45.95019486846407],
        [108.21121215820312, 45.99982360564013],
        [108.14529418945312, 46.10370875598026],
        [108.11370849609375, 46.193140876238004],
        [108.15765380859375, 46.27388525189855],
        [108.20571899414062, 46.337447097476925],
        [108.19198608398438, 46.39998810407942],
        [108.16726684570312, 46.43691049578133],
        [108.1219482421875, 46.48231911886259],
        [108.12057495117188, 46.544694144765536],
        [108.19610595703125, 46.64660795992221],
        [108.06976318359375, 46.68430518061324],
        [107.95663833618164, 46.77455369740659],
        [107.9568099975586, 46.77467126314099],
      ],
    ],
  },
};
